const state = {
  slug: "",
  completed: false
};

export default state;
